import { Grid, Container, Typography } from '@mui/material';
import { Icon } from '@iconify/react';

export default function Benefits() {
  const benefits = [
    {
      title: '¿Quieres vivir en una casa más sostenible?',
      text: 'Haz de tu día a día un espacio más sostenible para vivir un futuro mejor.',
      link: 'https://www.repsol.es/particulares/asesoramiento-consumo/momentos-energeticos/como-ser-mas-sostenible-en-casa/',
      linkText: 'Saber más',
      image:
        'https://www.repsol.es/content/dam/images-ecommerce/particulares/momentos-energéticos-/ser-sostenible-en-casa-card-L.jpg.transform/rp-rendition-lg/image.jpeg'
    },
    {
      title: '¿Vas a comprar un vehículo eléctrico?',
      text: 'Conoce cuáles son los criterios que debes tener en cuenta a la hora de cambiar de coche.',
      link: 'https://www.repsol.es/particulares/asesoramiento-consumo/momentos-energeticos/compra-de-vehiculo-electrico/',
      linkText: 'Saber más',
      image:
        'https://www.repsol.es/content/dam/images-ecommerce/particulares/momentos-energéticos-/consumo-coche-electrico-card-L.jpg.transform/rp-rendition-lg/image.jpeg'
    },
    {
      title: 'Si eres cliente de Luz y Gas, utiliza nuestra app para gestionar tu energía.',
      text: 'Ten a mano todos tus contratos y facturas de luz y gas, la gestión de tu consumo y mucho más.',
      link: 'https://www.repsol.es/particulares/digital/repsol-vivit/',
      linkText: 'Saber más',
      image:
        'https://www.repsol.es/content/dam/images-ecommerce/particulares/home-particulares/particulares-bien/particulares-09_Módulo-Distribuidor-Card-Standard-5-Cards.jpg.transform/rp-rendition-lg/image.jpeg'
    },
    {
      title: 'Waylet, ahorra en combustible y paga sin bajarte del coche',
      text: 'Grandes descuentos y ofertas exclusivas te esperan.',
      link: 'https://www.repsol.es/particulares/digital/waylet/',
      linkText: 'Saber más',
      image:
        'https://www.repsol.es/content/dam/images-ecommerce/particulares/waylet/cards/card-s-waylet-repsol-mas.jpg.transform/rp-rendition-lg/image.jpeg'
    },
    {
      title: 'Pide tu bombona online',
      text: 'Haz tu pedido de bombonas cuándo y dónde quieras.',
      link: 'https://www.repsol.es/particulares/digital/pide-tu-bombona/',
      linkText: 'Saber más',
      image:
        'https://www.repsol.es/content/dam/images-ecommerce/particulares/repsol-digital/04_Distribuidor-Card-Standard.jpg'
    }
  ];

  return (
    <Container>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography style={styles.titleSection}>Beneficios destacados</Typography>
        </Grid>
        <div style={styles.slider}>
          {benefits.map((benefit, index) => {
            return (
              <Grid key={index} item xs={12} md={4} style={styles.benefitCard}>
                <div
                  style={{
                    ...styles.benefitImage,
                    backgroundImage: 'url(' + benefit.image + ')'
                  }}
                ></div>
                <Typography style={styles.benefitTitle}>{benefit.title}</Typography>
                <Typography style={styles.benefitText}>{benefit.text}</Typography>
                {benefit.link &&
                  benefit.link !== '' &&
                  benefit.linkText &&
                  benefit.linkText !== '' && (
                    <a href={benefit.link} style={styles.benefitLink}>
                      {benefit.linkText}
                      <Icon icon="fa:angle-right" style={styles.iconArrow} />
                    </a>
                  )}
              </Grid>
            );
          })}
        </div>
      </Grid>
    </Container>
  );
}

const styles = {
  iconArrow: { verticalAlign: 'sub', marginLeft: 10, fontSize: 20 },
  titleSection: {
    color: '#ff6000',
    fontSize: 30,
    marginTop: 40,
    marginBottom: 30,
    fontFamily: "'Exo 2', sans-serif"
  },
  benefitCard: {
    width: 300,
    borderRadius: 10,
    display: 'inline-block',
    height: 400,
    position: 'relative' as 'relative',
    marginRight: 20,
    overflow: 'hidden' as 'hidden',
    backgroundColor: 'white',
    boxShadow: 'rgb(216 216 216) 1px 2px 9px'
  },
  benefitImage: {
    backgroundSize: 'cover' as 'cover',
    height: 150,
    width: '100%'
  },
  benefitTitle: {
    fontWeight: 700,
    color: '#4e4e4e',
    fontSize: 18,
    padding: '20px 20px 0px 20px',
    whiteSpace: 'break-spaces' as 'break-spaces',
    maxWidth: '100%',
    display: '-webkit-box' as '-webkit-box',
    WebkitBoxOrient: 'vertical' as 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden' as 'hidden',
    textOverflow: 'ellipsis' as 'ellipsis'
  },
  benefitText: {
    color: '#4e4e4e',
    fontSize: 14,
    padding: '10px 20px 20px 20px',
    whiteSpace: 'break-spaces' as 'break-spaces',
    maxWidth: '100%',
    display: '-webkit-box' as '-webkit-box',
    WebkitBoxOrient: 'vertical' as 'vertical',
    WebkitLineClamp: 4,
    overflow: 'hidden' as 'hidden',
    textOverflow: 'ellipsis' as 'ellipsis'
  },
  benefitLink: {
    color: '#2a8487',
    textDecoration: 'none' as 'none',
    fontWeight: 700,
    marginTop: 5,
    display: 'block' as 'block',
    position: 'absolute' as 'absolute',
    bottom: 0,
    padding: 20
  },
  slider: {
    overflow: 'hidden' as 'hidden',
    width: '100%',
    marginLeft: 30,
    whiteSpace: 'nowrap' as 'nowrap',
    overflowX: 'scroll' as 'scroll'
  }
};
